define([
	"csi/def",
	"csi/def/ActionFactory",
	"./_StateAction"
], function(def,ActionFactory,_StateAction) {

	return ActionFactory.declare("StartApprovalWorkflow", _StateAction, {
		m_module: "Workflow",
		m_tag: "StartApprovalWorkflow",

		constructor: function(obj) {
			if (!this.m_typeControl) {
				this.setMaterialIcon("play_circle_filled");
			}
		},

		_hasStateAccess: function(/*def.Context*/ctx, /*Node*/master, /*Node*/revision) {
			// summary: enable action if have a workflow
			return this.inherited(arguments) && this._hasAssignedWorkflow(ctx, master);
		}
	});
});